import React from 'react'
import ReactDOMServer from 'react-dom/server'
import { observer } from 'mobx-react'
import { GeoJSON, LayerGroup } from 'react-leaflet'
import Icon from '../common/Icon'

// Renders a boundary which is being previewed in the
// boundary-listing UI
const icon = ReactDOMServer.renderToString(React.createElement(Icon, { extraClasses: ['item-list__icon'], id: 'hexagon' }))

const BoundaryLayer = ({ boundaryList, targetGroup }) => (
  <LayerGroup>
    {
      boundaryList.selectedBoundary && boundaryList.selectedBoundary.is_zip_code &&
      boundaryList.selectedBoundary.geoJSON
        ? (
          <GeoJSON
            key={boundaryList.selectedBoundary.id}
            data={boundaryList.selectedBoundary.geoJSON}
            onEachFeature={(feature, layer) => {
              layer.on('click', () => {
                boundaryList.addBoundaryToSelection({
                  id: feature.properties.id, name: feature.properties.name, targetGroupId: targetGroup.pk, ids: [], isZipCode: true
                })
              })
              layer.bindPopup(`
                <div class='geojson-tooltip-container'>
                  <div>${icon}</div>
                  <div>${feature.properties.name}</div>
                </div>`, { className: 'geojson-tooltip' })
              layer.on('mouseover', () => layer.openPopup())
              layer.on('mouseout', () => layer.closePopup())
            }}
            smoothFactor={boundaryList.selectedBoundary.smoothFactor}
            className='region-buffer'
            style={
              {
                color: 'blue',
                weight: 3
              }
            }
            fillOpacity='0.6'
          />
          )
        : null
    }
  </LayerGroup>
)

export default observer(BoundaryLayer)
